import React from 'react'
import View from './view'

const BookingDetail = ({ ...props }) => {

    return <View {...props} />
}

export default BookingDetail
